export default "__VITE_ASSET__DqC3kctk__"